import React from 'react'
import cn from 'classnames'
import CanReadControl from './CanReadControl'
import CanWriteControl from './CanWriteControl'
import CreatorControl from './CreatorControl'
import Permissions from './Permissions'

import './permissionOption.less'

type PermissionUser = {
  id: string
  username?: string
  [key: string]: unknown
}

type PermissionPayload = {
  id: string
  username?: string | undefined
}

type PermissionOptionProps = {
  user: PermissionUser
  canRead?: boolean
  canWrite?: boolean
  viewOnly?: boolean | undefined
  isCreator?: boolean
  addReader?: ((payload: PermissionPayload) => void) | undefined
  removeReader?: ((payload: { id: string }) => void) | undefined
  addWriter?: ((payload: PermissionPayload) => void) | undefined
  removeWriter?: ((payload: { id: string }) => void) | undefined
}

const PermissionOption = ({ user, canRead: canReadProp, canWrite: canWriteProp, viewOnly, isCreator, addReader, removeReader, addWriter, removeWriter }: PermissionOptionProps) => {
  const canRead = !!canReadProp
  const canWrite = !!canWriteProp
  const { id, username } = user

  const readClicked = () => {
    if (canWrite) {
      if (removeWriter) {
        removeWriter({ id })
      }
    } else if (canRead) {
      if (removeReader) {
        removeReader({ id })
      }
    } else if (addReader) {
      addReader({ id, username })
    }
  }

  const writeClicked = () => {
    if (canWrite) {
      if (removeWriter) {
        removeWriter({ id })
      }
    } else if (addWriter) {
      addWriter({ id, username })
    }
  }

  let readers: Record<string, PermissionUser>
  let writers: Record<string, PermissionUser>
  readers = writers = {}
  let creator: PermissionUser | undefined
  let users: PermissionUser[] = []
  if (isCreator) {
    creator = user
  } else if (canWrite) {
    writers = { [id]: user }
  } else if (canRead) {
    readers = { [id]: user }
  } else {
    users = [user]
  }
  return (
    <div className={cn('permission-option')}>
      <div className="user-label">
        <Permissions {...(creator === undefined ? {} : { creator })} readers={readers} writers={writers} users={users} />
        {username}
      </div>
      <div className="toggles">
        {isCreator ? <CreatorControl viewOnly={viewOnly} /> : null}
        {!isCreator ? (
          <CanReadControl {...(viewOnly === undefined ? {} : { viewOnly })} canRead={canRead} onClick={readClicked} />
        ) : null}
        {!isCreator ? (
          <CanWriteControl
            {...(viewOnly === undefined ? {} : { viewOnly })}
            canWrite={canWrite}
            onClick={writeClicked}
          />
        ) : null}
      </div>
    </div>
  )
}

export default PermissionOption
